
/** 
 * @param {*} t
 * @return {*} 
 * @status no delete
 */
const RegistrationValidator = (t) => {
  let regexs = {
    nameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    firstLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    secondLastNameRegex: new RegExp(/^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]*$/),
    rfcRegex: new RegExp(/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    moralRfcRegex: new RegExp(/^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/),
    phoneRegex: new RegExp(/^[-]?[0-9]+[\.]?[0-9]+$/),
    nameSocialRegex: new RegExp(/^^[A-Za-zñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0 .,;:-]* ?()[A-Za-z0-9ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0& .,;:-]* ?()[A-Za-z0-9ñÑáéíóúáéíóúÁÉÍÓÚàèìòùÀÈÌÒÙ0& .,;:-]*$/),
    suburbRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    townRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    stateRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ.,;:-]+$/),
    zipCodeRegex: [
      { country: `${t('register.country.mx')}`, value: new RegExp(/^\d{5}$/) },
      { country: `${t('register.country.can')}`, value: new RegExp(/^(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\d(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\s{0,1}\d(?=[^DdFfIiOoQqUu\d\s])[A-Za-z]\d$/) },
      { country: `${t('register.country.usa')}`, value: new RegExp(/^\d{5}(?:-\d{4})?$/) },
    ],
    securityCode: new RegExp(/^[0-9]{3,4}$/),
    internalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
    externalNumberRegex: new RegExp(/^[A-Za-z0-9 áéíóúÁÉÍÓÚÑñ.,;:#-]+$/),
  }

  let validators = {
    nameValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.nameValidator')
      if (value && value.length > 0) {
        return (regexs.nameRegex.test(value) ? '' : t('registration.validator.nameValidator'))
      }
    },
    firstLastNameValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.firstLastNameValidator')
      if (value && value.length > 0) {
        return (regexs.firstLastNameRegex.test(value) ? '' : t('registration.validator.firstLastNameValidator'))
      }
    },
    secondLastNameValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.secondLastNameValidator')
      if (value && value.length > 0) {
        return (regexs.secondLastNameRegex.test(value) ? '' : t('registration.validator.secondLastNameValidator'))
      }
    },
    rfcValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.rfcValidato')
      return (regexs.rfcRegex.test(value.toUpperCase()) ? '' : t('registration.validator.rfcValidato'))
    },
    moralRfcValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.moralRfcRegex.test(value.toUpperCase()) ? '' : t('registration.validator.rfcValidato'))
      }
    },
    phoneValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.phoneRegex.test(value) ? '' : t('registration.validator.phoneValidato'))
      }
    },
    nameSocialValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.nameSocialValidato')
      return (regexs.nameSocialRegex.test(value) ? '' : t('registration.validator.nameSocialValidato'))
    },
    descriptionValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.descriptionValidator')
      return (regexs.nameSocialRegex.test(value) ? '' : t('registration.validator.descriptionValidator'))
    },
    suburbValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.suburbValidato')
      return (regexs.suburbRegex.test(value) ? '' : t('registration.validator.suburbValidato'))
    },
    townValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.townValidato')
      return (regexs.townRegex.test(value) ? '' : t('registration.validator.townValidato'))
    },
    stateValidator: (value) => {
      if (!value || value.trim() === '') return t('registration.validator.stateValidato')
      return (regexs.stateRegex.test(value) ? '' : t('registration.validator.stateValidato'))
    },
    zipCodeValidator: (value, country) => {
      if (!country) return;
      if (!value || value.trim() === '') return t('registration.validator.zipCodeValidato')
      const regexTest = regexs.zipCodeRegex.find(item => item.country === country);
      return (regexTest.value.test(value) ? '' : t('registration.validator.zipCodeValidato'))
    },
    internalNumberValidator: (value) => {
      if (value && value.length > 0) {
        return (regexs.internalNumberRegex.test(value) ? '' : t('registration.validator.internalNumberValidato'))
      }
    },
    externalNumberValidator: (value) => {
      if (!value || value.trim() === "") return t('registration.validator.externalNumberValidato')
      return (regexs.externalNumberRegex.test(value) ? '' : t('registration.validator.externalNumberValidato'))
    },
    requiredValidator: (value) => {
      if (!value || (typeof value === "string" && value.trim() === '')) return t('registration.validator.requiredField')
      return ''
    },
  }

  return validators
}

export { RegistrationValidator as default }
